import { useState, useEffect } from "react";
import { supa } from "./firebase";

function ModalPersonal({ visible, setVisible, aggiorna, pilates }) {
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [notes, setNotes] = useState('');
    const [users, setUsers] = useState([])
    const [selectedUser, setSelectedUser] = useState(null)
    const [pacchetti, setPacchetti] = useState([])
    const [selectedPacchetto, setSelectedPacchetto] = useState(null)
    const [inizio, setInizio] = useState(new Date());
    const [fine, setFine] = useState(new Date());
    const [totale, setTotale] = useState(0);
    const [acconto, setAcconto] = useState(0);
    const [filter, setFilter] = useState('')
    const [selectVisible, setSelectVisible] = useState(false)

    const setVisibleSelect = (value) => {
        setSelectVisible(value)
    }

    async function addRow() {
        if (!selectedUser || !selectedPacchetto || !totale) {
            alert('Inserire tutti i campi')
            return
        }
        const { data, error } = await supa
            .from('pacchettiAcquistati')
            .insert({ "id_utente": selectedUser, "id_pacchetto": selectedPacchetto, "inizio": inizio, "fine": fine, "totale": totale, "acconto": acconto, "note": notes, "tipo": pilates ? 1 : 0 })
            .select()
        if (error) console.log(error)
            if (acconto > 0){
        const { data2, error2 } = await supa
            .from('versamenti')
            .insert({ "id_utente": selectedUser, "id_pacchettiAcquistati": data[0].id, "data": new Date(), "importo": acconto })
        if (error2) console.log(error2)
        }
        aggiorna()
        setVisible(false)
    }

    async function getUtenti() {
        const { data, error } = await supa
            .from('utenti')
            .select('*')
        if (error) console.log(error)
        data.sort((a, b) => a.nome.localeCompare(b.nome) || a.cognome.localeCompare(b.cognome))
        if (data.length > 0) setSelectedUser(data[0].id)
        setUsers(data)
    }

    async function getPacchetti() {
        const { data, error } = await supa
            .from('pacchetti')
            .select('*')
            .eq('tipo', pilates ? 1 : 0)
        if (error) console.log(error)
        if (data.length > 0) setSelectedPacchetto(data[0].id)
        setPacchetti(data)
    }

    useEffect(() => {
        getUtenti()
        getPacchetti()
    }
        , [])

    useEffect(() => {
        setTotale(pacchetti.find(item => item.id == selectedPacchetto)?.prezzo)
    }, [selectedPacchetto])


    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            {users.length > 0 && pacchetti.length > 0 &&
                <div className="relative w-full max-w-2xl mx-4 animate-in fade-in zoom-in duration-200">
                    <div className="relative bg-white rounded-2xl shadow-2xl border border-zinc-200">
                        {/* Header */}
                        <div className="flex items-center justify-between p-6 border-b border-zinc-200">
                            <div>
                                <h3 className="text-2xl font-bold text-zinc-900">Nuovo Acquisto Pacchetto</h3>
                                <p className="text-sm text-zinc-600 mt-1">Registra l'acquisto di un nuovo pacchetto {pilates ? 'Pilates' : 'Personal'}</p>
                            </div>
                            <button 
                                onClick={() => setVisible(false)} 
                                className="p-2 text-zinc-400 hover:text-zinc-600 hover:bg-zinc-100 rounded-lg transition-all"
                            >
                                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        {/* Body */}
                        <form className="p-6">
                            <div className="grid gap-6 mb-6 md:grid-cols-2">
                                <div className="md:col-span-2">
                                    <label className="block mb-2 text-sm font-semibold text-zinc-700">Utente</label>
                                    <div className="relative group">
                                        <div 
                                            onClick={() => setSelectVisible(!selectVisible)} 
                                            className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm flex justify-between items-center cursor-pointer hover:bg-zinc-100 transition-all"
                                        >
                                            <span className="text-zinc-900">{users.find(item => item.id == selectedUser)?.nome} {users.find(item => item.id == selectedUser)?.cognome} ({users.find(item => item.id == selectedUser)?.birth ? new Date(users.find(item => item.id == selectedUser)?.birth).toLocaleDateString('it-IT') : ""})</span>
                                            <svg className="w-5 h-5 text-zinc-400" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M6.293 9.293a1 1 0 011.414 0L10 11.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                                            </svg>
                                        </div>
                                        {selectVisible && 
                                            <div className="absolute noBar z-10 w-full mt-2 rounded-xl shadow-2xl bg-white border border-zinc-200 p-2 space-y-1 max-h-80 overflow-y-scroll">
                                                <input 
                                                    onChange={(e) => setFilter(e.target.value)} 
                                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-lg text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all" 
                                                    type="text" 
                                                    placeholder="Cerca utente..." 
                                                />
                                                {users.filter((item) => item.nome.toLowerCase().includes(filter.toLowerCase()) || item.cognome.toLowerCase().includes(filter.toLowerCase())).map((item, index) => (
                                                    <button 
                                                        onClick={() => { setSelectedUser(item.id); setSelectVisible(false) }} 
                                                        key={index} 
                                                        type="button"
                                                        className="w-full px-4 py-2.5 text-left text-zinc-800 hover:bg-yellow-50 rounded-lg transition-all"
                                                    >
                                                        {item.nome} {item.cognome} ({item.birth ? new Date(item.birth).toLocaleDateString('it-IT') : ""})
                                                    </button>
                                                ))}
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="md:col-span-2">
                                    <label className="block mb-2 text-sm font-semibold text-zinc-700">Pacchetto</label>
                                    <select 
                                        onChange={(e) => setSelectedPacchetto(parseInt(e.target.value))} 
                                        className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all"
                                    >
                                        {pacchetti.map((item, index) => (
                                            <option key={index} value={item.id}>{item.nome} - {item.num_lezioni} lezioni - {item?.prezzo} €</option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block mb-2 text-sm font-semibold text-zinc-700">Data Inizio</label>
                                    <input 
                                        type="date" 
                                        onChange={(e) => setInizio(e.target.value)} 
                                        className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 text-sm font-semibold text-zinc-700">Data Fine</label>
                                    <input 
                                        type="date" 
                                        onChange={(e) => setFine(e.target.value)} 
                                        className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 text-sm font-semibold text-zinc-700">Totale (€)</label>
                                    <input 
                                        type="number" 
                                        value={totale} 
                                        onChange={(e) => setTotale(e.target.value)} 
                                        className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all" 
                                        placeholder="0.00"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 text-sm font-semibold text-zinc-700">Acconto (€)</label>
                                    <input 
                                        type="number" 
                                        onChange={(e) => setAcconto(e.target.value)} 
                                        className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all" 
                                        placeholder="0.00"
                                    />
                                </div>
                                <div className="md:col-span-2">
                                    <label className="block mb-2 text-sm font-semibold text-zinc-700">Eventuali Note</label>
                                    <textarea 
                                        onChange={(e) => setNotes(e.target.value)} 
                                        rows="4"
                                        className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all resize-none" 
                                        placeholder="Inserisci note..."
                                    ></textarea>
                                </div>
                            </div>

                            {/* Footer */}
                            <div className="flex items-center justify-end gap-3 pt-4 border-t border-zinc-200">
                                <button 
                                    type="button"
                                    onClick={() => setVisible(false)}
                                    className="px-5 py-2.5 text-sm font-semibold text-zinc-700 bg-zinc-100 hover:bg-zinc-200 rounded-xl transition-all"
                                >
                                    Annulla
                                </button>
                                <button 
                                    type="button"
                                    onClick={() => addRow()}
                                    className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-zinc-900 bg-yellow-400 hover:bg-yellow-500 rounded-xl shadow-sm hover:shadow transition-all"
                                >
                                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd"></path>
                                    </svg>
                                    Aggiungi Acquisto
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            }
        </div>
    );
}

export default ModalPersonal;
